export default "__VITE_ASSET__CXqF2Rhc__"